import React from "react"

import {alpha, styled} from '@mui/material/styles'
import {IconButton, InputBase} from "@mui/material"

import SearchIcon from "@mui/icons-material/Search"
import CloseIcon from "@mui/icons-material/Close"


const Search = styled('div')(({theme}) => ({
    position       : 'relative',
    borderRadius   : theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.black, 0.15),
    '&:hover'      : {
        backgroundColor: alpha(theme.palette.common.black, 0.25),
    },
    marginLeft     : 0,
    width          : '100%',
}))

const SearchIconWrapper = styled('div')(({theme}) => ({
    padding       : theme.spacing(0, 2),
    height        : '100%',
    position      : 'absolute',
    pointerEvents : 'none',
    display       : 'flex',
    alignItems    : 'center',
    justifyContent: 'center',
}))

const StyledInputBase = styled(InputBase)(({theme}) => ({
    color                  : 'inherit',
    width                  : '100%',
    marginRight            : '-3rem',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition : theme.transitions.create('width'),
        width      : '100%',
        marginRight: '2rem'
    },
}))

const SearchClose = styled(IconButton)(({theme}) => ({
    float: 'right'
}))

type SearchBarProps = {
    value: string
    onChange: (value: string) => void
}
const SearchBar = (props: SearchBarProps) => {
    const {value, onChange} = props

    return <Search>
        <SearchIconWrapper>
            <SearchIcon/>
        </SearchIconWrapper>
        <StyledInputBase
            placeholder="Recherche..."
            inputProps={{'aria-label': 'recherche chanson par titre ou artiste'}}
            value={value}
            onChange={e => onChange(e.currentTarget.value)}
        />
        {
            value !== '' ?
                <SearchClose onClick={() => onChange('')}>
                    <CloseIcon/>
                </SearchClose>
                : null
        }

    </Search>
}

export default SearchBar
